import * as React from 'react';
import { StyledTitle } from '../../common';
import DefaultDialog from '../../DefaultDialog';

interface Props {
	onIssue: () => void;
	cancel: () => void;
}

export default function ConfirmIssueModal(props: Props) {
	const { onIssue, cancel } = props;

	const heading = <StyledTitle>{'Issue Cancellation'}</StyledTitle>;

	return (
		<>
			<DefaultDialog
				actions={[
					{ text: 'Issue', onClick: onIssue },
					{ text: 'Cancel', onClick: cancel },
				]}
				open
				onClose={close}
				title={heading}
			>
				Are you sure you want to issue this cancellation?
			</DefaultDialog>
		</>
	);
}
